// src/components/ReviewForm.js

import React, { useState } from 'react';
import { Box, Typography, TextField, Rating, Button } from '@mui/material';
import PropTypes from 'prop-types';

const ReviewForm = ({ onSubmit }) => {
    const [rating, setRating] = useState(5);
    const [comment, setComment] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ rating, comment });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
                Leave a Review
            </Typography>
            <Rating
                name="rating"
                value={rating}
                onChange={(event, newValue) => {
                    setRating(newValue);
                }}
                sx={{ mb: 2 }}
            />
            <TextField
                fullWidth
                label="Comment"
                multiline
                rows={4}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                variant="outlined"
                required
                sx={{ mb: 2 }}
            />
            <Button type="submit" variant="contained" color="primary">
                Submit Review
            </Button>
        </Box>
    );
};

ReviewForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default ReviewForm;
